import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { services } from '../data/content';
function Services() {
  return (
    <section className="pad" id="services">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">What I do</span>
          <h2 className="h-section">Services I offer</h2>
          <p>End-to-end development — from the first wireframe to the last migration. Pick one piece or the whole stack.</p>
        </div>
        <div className="svc-grid">
          {services.map((s, i) => {
            const Icon = FiIcons[s.icon];
            return (
              <motion.div className="svc-card" key={s.num} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
                <span className="svc-num">{s.num}</span>
                <div className="svc-icon"><SafeIcon icon={Icon} /></div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
export default Services;
